import React, { useEffect, useState, useRef, memo } from 'react';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon, GiftIcon } from 'lucide-react';
export function Reviews() {
  // Bonus Carousel State
  const [currentBonusSlide, setCurrentBonusSlide] = useState(0);
  const [isBonusPaused, setIsBonusPaused] = useState(false);
  // Lifestyle Carousel State
  const [currentLifestyleSlide, setCurrentLifestyleSlide] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const bonusImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/5kLpWKCYRC5pzE7Ziozm6U/ptd.d_menus_festivos.png',
    alt: 'Menús Festivos Exprés de Navidad & Año Nuevo',
    value: '$27 USD'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/c4DpvMeT2KB3ZFftiuZRYp/ptda.kit_antisobrantes.png',
    alt: 'Kit Anti-Sobrantes Navidad & Año Nuevo',
    value: '$19 USD'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/dGVEhzmYDNbG5UXroHe5iw/portd.calculadora.png',
    alt: 'Calculadora de Fiesta Navideña',
    value: '$15 USD'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/4DX33aZovz7HKPk7wyc1ui/portada_de_KIT.png',
    alt: 'Kit Imprimible & Editable de Menús',
    value: '$22 USD'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/491VLAVVGxM8Xt439CkNvE/portada_principal.png',
    alt: 'Loncheras Que los Niños Devoran',
    value: '$25 USD'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/diBgsWNVKXeMATeqnyV5Ue/img_de_potrtda_de_7_dias_de_cenas_en_15_minutos.png',
    alt: '7 Días de Cenas en 15 Minutos',
    value: '$17 USD'
  }];
  const lifestyleImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/t9xGqmjHtNrQ4FzEHvzzbV/ChatGPT_Image_3_nov_2025,_10_26_32_p.m..png',
    alt: 'Mamá leyendo 50 Recetas en el auto'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/q6sVLS2CBzcXBH4h2v5kZS/modelo2.png',
    alt: 'Mujer profesional con tablet en la cocina'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/xACv3oifnfjjGxfryTRrHW/mujer_profesional_leyendo_50_recetas.png',
    alt: 'Profesional leyendo 50 Recetas'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/pG5e9BnYNTgkbxwqkhKy9h/madre_leyeno_50_recetas.png',
    alt: 'Madre e hija leyendo juntas'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/eaTdhDhoKB42AJJz5GPivQ/2portada_50_recetas.jpg',
    alt: 'Libro 50 Recetas de 15 Minutos'
  }];
  const reviews = [{
    initials: 'AM',
    date: '20/01/2025',
    name: 'Ana M.',
    location: 'Houston, TX (mamá y enfermera)',
    title: 'Ya no siento culpa',
    content: 'Entre el trabajo y la escuela de los niños, siempre terminaba pidiendo comida. Con este libro, en 15 minutos tengo cena casera y variada. Mis hijos se comen todo y yo ya no siento culpa. Lo mejor: ingredientes sencillos y pasos claros. Fue el empujón que necesitaba para organizarme.',
    rating: 5
  }, {
    initials: 'LR',
    date: '18/01/2025',
    name: 'Luis R.',
    location: 'Ciudad de México (papá soltero)',
    title: 'Me salvó entre semana',
    content: 'Me salvó entre semana. Los menús están pensados para la vida real: poco tiempo, mucho sabor. Armé una lista de 10 recetas favoritas y las repito. Gastamos menos en delivery y comemos mejor. Recomendado para papás con agenda apretada.',
    rating: 5
  }, {
    initials: 'VP',
    date: '16/01/2025',
    name: 'Valeria P.',
    location: 'Buenos Aires (maestra y mamá de 2)',
    title: 'Volví a disfrutar las noches',
    content: 'Volví a disfrutar las noches. Ya no improviso. Sigo la guía, cocino en 15 minutos y listo. Los molletes exprés y la pasta con maíz son éxito seguro. Además, los consejos de "preparaciones base" me ahorran tiempo toda la semana.',
    rating: 5
  }];
  // Auto-play logic for Bonus Carousel
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (!isBonusPaused) {
      interval = setInterval(() => {
        setCurrentBonusSlide(prev => (prev + 1) % bonusImages.length);
      }, 4000);
    }
    return () => clearInterval(interval);
  }, [isBonusPaused, bonusImages.length]);
  const nextBonusSlide = () => {
    setCurrentBonusSlide(prev => (prev + 1) % bonusImages.length);
  };
  const prevBonusSlide = () => {
    setCurrentBonusSlide(prev => (prev - 1 + bonusImages.length) % bonusImages.length);
  };
  // Lifestyle Carousel Logic
  const nextLifestyleSlide = () => {
    setCurrentLifestyleSlide(prev => (prev + 1) % lifestyleImages.length);
  };
  const prevLifestyleSlide = () => {
    setCurrentLifestyleSlide(prev => (prev - 1 + lifestyleImages.length) % lifestyleImages.length);
  };
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.targetTouches[0].clientX);
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 75) {
      nextLifestyleSlide();
    }
    if (touchStart - touchEnd < -75) {
      prevLifestyleSlide();
    }
  };
  return <section id="reviews" className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-white to-gray-50" data-id="element-600">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-601">
        {/* TESTIMONIALS SECTION */}
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-3" data-id="element-602">
          Lo Que Dicen las Familias
        </h2>
        <div className="text-center mb-8" data-id="element-603">
          <div className="text-2xl font-bold text-gray-900" data-id="element-604">4.9</div>
          <div className="text-sm text-gray-500" data-id="element-605">Basado en 2,847 Familias</div>
        </div>
        <div className="space-y-6" data-id="element-606">
          {reviews.map((review, index) => <div key={index} className="border border-amber-100 rounded-xl p-6 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-607">
              <div className="flex flex-col items-center text-center md:flex-row md:items-start md:text-left gap-4" data-id="element-608">
                <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-orange-600 text-white rounded-full flex items-center justify-center font-bold text-lg shadow-md flex-shrink-0" data-id="element-609">
                  {review.initials}
                </div>
                <div className="flex-1" data-id="element-610">
                  <div className="flex items-center justify-center md:justify-start gap-2 mb-2" data-id="element-611">
                    <div className="flex" data-id="element-612">
                      {[...Array(review.rating)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-613" />)}
                    </div>
                    <span className="text-sm text-gray-400" data-id="element-614">{review.date}</span>
                  </div>
                  <div className="font-semibold text-gray-900 mb-1" data-id="element-615">
                    {review.name}
                  </div>
                  <div className="text-sm text-gray-500 mb-3" data-id="element-616">
                    {review.location}
                  </div>
                  <h3 className="font-bold mb-2 text-amber-600" data-id="element-617">
                    {review.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-618">
                    {review.content}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}